import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';

export const DOG_BREED_INTEREST_SUBSCRIPTION = graphql(`
  query DogBreedInterestSubscription($where: DogBreedInterestSubscriptionWhereInput) {
    findManyDogBreedInterestSubscription(where: $where, take: 1) {
      id
      dogBreeds {
        id
        name
      }
    }
  }
`);

export const useGetDogBreedInterestSubscription = (email?: string | null) => {
  const { data, loading } = useQuery(DOG_BREED_INTEREST_SUBSCRIPTION, {
    ssr: false,
    variables: {
      where: {
        emailContact: { is: { email: { equals: email } } },
      },
    },
    skip: !email,
  });

  return {
    dogBreedInterestSubscription: data?.findManyDogBreedInterestSubscription?.[0],
    dogBreedInterestSubscriptionLoading: loading,
  };
};
